const ImageSizes = {
    xsmall: { imageHeight: 32, imageWidth: 32 },
    small: { imageHeight: 48, imageWidth: 48 },
    medium: { imageHeight: 64, imageWidth: 64 },
    large: { imageHeight: 100, imageWidth: 100 },
    xlarge: { imageHeight: 120, imageWidth: 120 },
    flex: { imageHeight: 0, imageWidth: 0 },
};
export const getImageSizeStyle = (size = 'medium') => {
    return ImageSizes[size];
};
export const getContainerStyle = (activeSize, icon, theme, imageHeight, imageWidth, imageFit) => {
    return {
        position: 'relative',
        height: 'fit-content',
        width: activeSize === 'flex' ? '100%' : 'fit-content',
        maxWidth: activeSize === 'flex' ? '9.6rem' : 'initial', // Max width defined by component styles.
        aspectRatio: activeSize === 'flex' ? '1 / 1' : 'initial',
        overflow: 'hidden',
        display: 'flex',
        gap: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '1px',
        padding: theme.spacing[200],
        border: `${theme.borderWidth[25]} solid ${theme.color.border.base}`,
        '&:hover': {
            background: 'initial!important',
            boxShadow: theme.shadow.subtle,
        },
        '& img': {
            width: activeSize === 'flex' ? '100%' : imageHeight,
            height: activeSize === 'flex' ? '100%' : imageWidth,
            aspectRatio: activeSize === 'flex' ? '1 / 1' : 'initial',
            borderRadius: imageFit === 'cover' ? '0.2rem' : 'initial',
        },
        '& svg': {
            circle: {
                display: activeSize === 'xsmall' || activeSize === 'small' || icon === 'actionIcon'
                    ? 'none'
                    : 'initial',
            },
        },
    };
};
export const getIconContainerStyle = (activeSize) => {
    return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: activeSize !== 'xsmall' ? 'flex' : 'none',
        justifyContent: 'center',
        left: 0,
        top: 0,
        '& svg': {
            width: '50%',
            height: '50%',
            alignSelf: 'center',
        },
    };
};
export const getLabelContainerStyle = (activeSize) => {
    return {
        display: activeSize === 'xlarge' ? 'initial' : 'none',
        '& svg': {
            display: 'initial',
        },
    };
};
//# sourceMappingURL=ButtonImage.styles.js.map